import { useNavigate } from "react-router-dom";
import "../../../assets/css/customer/ourStory/OurStory.css";

const OurStory = () => {
  const navigate = useNavigate();
  return (
    <div className="story-wrapper">
      <section className="story-section">
        <div className="story-content">
          <div className="story-box">
            <h1 className="story-title">OUR STORY</h1>
            <p className="story-description">
              We believe in creativity as one of the major forces of progress.
              With this idea, we traveled throughout Italy to find exceptional
              artisans and bring their unique handcrafted objects to
              connoisseurs everywhere.
            </p>
            <button
              className="story-button"
              onClick={() => {
                navigate("/our-story");
              }}
            >
              Read full story
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OurStory;
